export default __webpack_public_path__ + "static/media/wholesale_logo.6fabdc4d.png";